  <div class="cookie-modal scroll1" style="overflow-y: auto;" >
    <div class="col-12 p-0 m-0" >

    
    <div class="cookie-header" *ngIf="!inPage">
      <h2 style=" font-family: 'Noto Sans', sans-serif;">Manage Cookie Preference</h2>
      <span (click)="close()" class="close-btn"><img src="https://ik.imagekit.io/qdesq/qdesq/51542ea2a2b5be64cc3948c8386226d0_nxYVC7ndv.svg" alt="close-icon"></span>
    </div>
    <p class="cookie-description" [style.marginTop]=" inPage ? '0px': '12px'">
      Cookies used on this site are grouped into categories. Below, you can review each category and choose to allow or deny some or all of them. If you disable any previously allowed category, all cookies associated with it will be removed from your browser. You can also view a list of cookies under each category, along with detailed information in the cookie declaration.
    </p>

    <div class="col-12 p-0 m-0" style="display: flex;flex-wrap: wrap;gap: 16px !important;">
         <button class="btn outline" (click)="acceptAllCookie()">Accept all cookies</button>
      <button class="btn outline " (click)="saveOnlyNecessary()">Accept necessary cookies only</button>
    </div>

    <div class="cookie-section">
      <div class="cookie-title">
        <span>Essential Cookies</span>
        <span class="always-enabled">Always Enabled</span>
      </div>
      <div class="cookie-description2 font14Regular blackSubHeading">These cookies are necessary for the functioning of the Website and cannot be switched off in our systems.</div>
    </div>

    <div class="cookie-section">
      <div class="cookie-title">
        <span>Analytics Cookies</span>
        <span>
             {{cookieModal?.analytics ? 'Yes' : 'No'}}
              <mat-slide-toggle
              style="margin-left: 10px;"
              class="custom-toggle"
              [checked]="cookieModal?.analytics"
              [(ngModel)]="cookieModal.analytics"
             
           >
              
            </mat-slide-toggle>
            
        </span>
       
      </div>
      <div class="cookie-description2 font14Regular blackSubHeading">These help us understand how visitors interact with the Website by collecting and reporting information anonymously. We may use tools like Google Analytics.</div>
    </div>

    <div class="cookie-section">
      <div class="cookie-title">
        <span>Marketing Cookies</span>
        <span>
            {{cookieModal?.marketing ? 'Yes' : 'No'}}
             <mat-slide-toggle
              style="margin-left: 10px;"
              class="custom-toggle"
               [checked]="cookieModal?.marketing"
              [(ngModel)]="cookieModal.marketing"
           >
              
        </mat-slide-toggle>
        </span>
      </div>
      <div class="cookie-description2 font14Regular blackSubHeading">These cookies may be set through our site by our advertising partners such as Meta or/and Google Ads to build a profile of your interests and show you relevant ads.</div>
    </div>

    <div class="cookie-section">
      <div class="cookie-title">
        <span>Unclassified Cookies</span>
        <span>
             {{cookieModal?.unclassified ? 'Yes' : 'No'}}
             <mat-slide-toggle
              style="margin-left: 10px;"
              class="custom-toggle"
              [checked]="cookieModal?.unclassified"
              [(ngModel)]="cookieModal.unclassified"
           >
              
           </mat-slide-toggle>
        </span>
        
      </div>
      <div class="cookie-description2 font14Regular blackSubHeading" >These cookies are set by domains other than the one you are visiting, including services like embedded videos, social media widgets, or analytics providers.</div>
    </div>
    </div>
   
  </div>
   <div class="cookie-actions" style="border-top: 1px solid #F3EFEF;">
      <!-- <button class="btn outline">Reject All</button> -->
      <!-- <button class="btn outline">Save My Preferences</button> -->
      <button (click)="savePreferences()" class="btn filled" style="margin: auto;min-width: 226px;margin-top: 20px !important;">Save Settings</button>
    </div>